module.exports = __webpack_public_path__ + "img/swiss_eco_bags_logo_white.dcb92a53.svg";